import { ArrowLeft } from 'lucide-react';
import { BROAD_LABELS, setBroadState } from '@/lib/company-qualification';
import { WorkingHypotheses } from '@/components/profile/WorkingHypotheses';
import { type BroadState, type CompanyQualificationSheet, BROAD_STATES } from '@shared/types/company-qualification';

interface Props {
  sheet: CompanyQualificationSheet;
  onChange: (sheet: CompanyQualificationSheet) => void;
  onBack: () => void;
}

/** Above the detailed sheet: the way back, the state of the qualification, the analyst's working hypotheses. */
export const QualificationSheetHeader = ({ sheet, onChange, onBack }: Props) => (
  <div className="space-y-4">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <button type="button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-domino-inkSoft hover:text-domino-ink">
        <ArrowLeft className="h-4 w-4" aria-hidden /> Tous les thèmes
      </button>
      <select
        aria-label="État de la qualification"
        value={sheet.broad.state}
        onChange={(event) => onChange(setBroadState(sheet, event.target.value as BroadState))}
        className="h-8 rounded-lg border border-domino-cardBorder bg-domino-warm px-2 text-sm text-domino-ink"
      >
        {BROAD_STATES.map((state) => <option key={state} value={state}>{BROAD_LABELS[state]}</option>)}
      </select>
    </div>
    <WorkingHypotheses sheet={sheet} onChange={onChange} className="rounded-xl border border-domino-cardBorder bg-domino-warm px-5 py-4" />
  </div>
);
